<!--
 * @description: 代码生成器自动生成
 * @author: liyubao | xufuxing
 * @version: 1.0
-->
<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="small" style="width: 100px;" class="filter-item"
          :placeholder="'配件名称'" v-model="listQuery.name" clearable> </el-input>
        <el-input @keyup.enter.native="handleFilter" size="small" style="width: 100px;" class="filter-item"
          :placeholder="'配件编号'" v-model="listQuery.code" clearable> </el-input>
        <el-input @keyup.enter.native="handleFilter" size="small" style="width: 100px;" class="filter-item"
          :placeholder="'资产编号'" v-model="listQuery.assetCode" clearable> </el-input>
        <el-input @keyup.enter.native="handleFilter" size="small" style="width: 100px;" class="filter-item"
          :placeholder="'型号'" v-model="listQuery.model" clearable> </el-input>
        <el-input @keyup.enter.native="handleFilter" size="small" style="width: 100px;" class="filter-item"
          :placeholder="'状态'" v-model="listQuery.status" clearable> </el-input>
        <el-button class="filter-item" size="small" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <el-button class="filter-item" size="small" v-waves icon="el-icon-refresh" @click="handleReset">重置</el-button>
        <permission-btn size="small" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table style="height:calc(100% - 60px)" ref="mainTable" :select-type="'checkbox'"
          :table-fields="headerList" :data="list" :v-loading="listLoading" @row-dblclick="onBtnClicked('btnEdit')"
          @row-click="rowClick" @selection-change="handleSelectionChange" :enable-sorting="true"
          :enable-custom-filter="true"></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange" />
      </div>
      <el-dialog v-el-drag-dialog class="dialog-mini" width="500px" :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible">
        <div slot="footer">
          <el-button size="small" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="small" v-if="dialogStatus == 'create'" type="primary" @click="createData">确认</el-button>
          <el-button size="small" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>

      <el-dialog title="批量修改" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <el-form :model="batchForm" ref="batchForm" label-width="100px">
          <!-- 下拉选择要修改的字段 -->
          <el-form-item label="修改字段" prop="field">
            <el-select v-model="batchForm.field" placeholder="请选择要修改的字段" @change="handleFieldChange">
              <el-option v-for="item in editableFields" :key="item.columnName" :label="item.remark"
                :value="item.columnName">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 输入新值 -->
          <el-form-item label="新值" prop="value">
            <el-input v-model="batchForm.value" placeholder="请输入新值" :type="inputType">
            </el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleBatchUpdate">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 配件使用对话框 -->
      <el-dialog title="配件使用" :visible.sync="useDialogVisible" width="500px">
        <el-form :model="useForm" ref="useForm" label-width="100px">
          <el-form-item label="选择资产" prop="assetCode">
            <el-input v-model="useForm.assetCode" placeholder="点击选择资产" readonly>
              <el-button slot="append" icon="el-icon-search" @click="openAssetSelector"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="资产名称" prop="assetName">
            <el-input v-model="useForm.assetName" placeholder="资产名称" readonly></el-input>
          </el-form-item>
          <el-form-item label="更换日期" prop="updateTime">
            <el-date-picker v-model="useForm.updateTime" type="datetime" placeholder="选择更换日期"
              value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="useDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleAccessoryUse">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 资产选择对话框 -->
      <el-dialog title="选择资产" :visible.sync="assetSelectorVisible" width="900px" append-to-body>
        <div style="margin-bottom: 10px;">
          <el-input v-model="assetSearchKey" placeholder="输入资产编号或名称搜索" size="small" style="width: 200px;"
            @keyup.enter.native="searchAssets" clearable>
            <el-button slot="append" icon="el-icon-search" @click="searchAssets"></el-button>
          </el-input>
        </div>
        <el-table :data="assetList" v-loading="assetListLoading" height="400px" border highlight-current-row
          @row-click="selectAsset" style="cursor: pointer;">
          <el-table-column prop="assetCode" label="资产编号" width="120"></el-table-column>
          <el-table-column prop="assetName" label="资产名称" width="150"></el-table-column>
          <el-table-column prop="specification" label="规格型号" width="150"></el-table-column>
          <el-table-column prop="useDepartment" label="使用部门" width="120"></el-table-column>
          <el-table-column prop="useMan" label="使用人" width="100"></el-table-column>
          <el-table-column prop="storeName" label="仓库" width="100"></el-table-column>
        </el-table>
        <pagination v-show="assetTotal > 0" :total="assetTotal" :page.sync="assetQuery.page"
          :limit.sync="assetQuery.limit" @pagination="handleAssetPageChange" />
      </el-dialog>

      <importDialog ref="ImportDialog" v-show="importDialogVisible" @reloadTable="getList" :FileName="FileName"
        :url="url"></importDialog>
    </div>
  </div>
</template>
<script>
import * as assetAccessorys from '@/api/basic/assetAccessorys'
import * as assetInfos from '@/api/basic/assetInfos'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import { defaultVal } from '@/utils/index'
import extend from '@/extensions/common.js'
import AuthTable from '../../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
import importDialog from '../../../components/Base/importDialog.vue'
export default {
  name: 'assetAccessory',
  components: { Sticky, permissionBtn, Pagination, AuthTable, importDialog },
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      dialogVisible: false,
      batchForm: {
        field: '',  // 选择的字段
        value: ''   // 新值
      },
      inputType: 'text',  // 输入框类型
      useDialogVisible: false,  // 配件使用对话框
      useForm: {
        assetCode: '',
        assetName: '',
        updateTime: ''
      },
      currentAccessory: null,  // 当前选中的配件
      assetSelectorVisible: false,  // 资产选择对话框
      assetList: [],  // 资产列表
      assetTotal: 0,  // 资产总数
      assetListLoading: false,  // 资产列表加载状态
      assetSearchKey: '',  // 资产搜索关键字
      assetQuery: {
        page: 1,
        limit: 10,
        key: undefined
      },
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      FileName: '资产配件导入模版.xlsx',
      url: '/AssetAccessorys/Import',
      importDialogVisible: false,
      listQuery: {
        // 查询条件
        page: 1,
        limit: 20,
        name: undefined,           // 配件名称
        code: undefined,           // 配件编号
        assetCode: undefined,      // 资产编号
        model: undefined,          // 型号
        status: undefined,         // 状态
      },
      temp: {},
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
      },
    }
  },
  computed: {
    // 过滤掉不可批量修改的字段
    editableFields() {
      const excludeFields = ['status', 'createTime', 'updateTime'];
      return this.headerList.filter(item => !excludeFields.includes(item.columnName));
    }
  },
  created() {
    this.headerList = [
      new ColumnDefine('assetCode', '资产编号', true, true, '', '', 'string', 'varchar', 'AssetCode'),
      new ColumnDefine('assetName', '资产名称', true, true, '', '', 'string', 'varchar', 'AssetName'),
      new ColumnDefine('code', '配件编号', true, true, '', '', 'string', 'varchar', 'Code'),
      new ColumnDefine('name', '配件名称', true, true, '', '', 'string', 'varchar', 'Name'),
      new ColumnDefine('model', '型号', true, true, '', '', 'string', 'varchar', 'Model'),
      new ColumnDefine('unit', '单位', true, true, '', '', 'string', 'varchar', 'Unit'),
      new ColumnDefine('totalQty', '数量', true, true, '', '', 'int', 'int', 'TotalQty'),
      new ColumnDefine('unitPrice', '单价', true, true, '', '', 'decimal', 'decimal', 'UnitPrice'),
      new ColumnDefine('amount', '金额', true, true, '', '', 'string', 'varchar', 'Amount'),
      new ColumnDefine('status', '状态', true, true, '', '', 'string', 'varchar', 'Status'),
      new ColumnDefine('createName', '登记人', true, true, '', '', 'string', 'varchar', 'CreateName'),
      new ColumnDefine('createTime', '创建日期', true, true, '', '', 'string', 'datetime2', 'CreateTime'),
      new ColumnDefine('updateTime', '更换日期', true, true, '', '', 'string', 'datetime2', 'UpdateTime'),

    ]
    this.getList()
  },
  methods: {

    rowClick(row) {
      this.$refs.mainTable.clearSelection()
      this.$refs.mainTable.toggleRowSelection(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onBtnClicked: function (domId, callback) {
      console.log('you click:' + domId)
      switch (domId) {
        case 'btnRecovery':
          // 配件收回
          this.handleRecovery()
          break
        case 'btnAccessoryUsage':
          // 配件使用
          this.handleAccessoryUsage()
          break
        case 'Import':
          this.FileName = '资产配件导入模版.xlsx';
          this.url = '/AssetAccessorys/StationImport';
          this.importDialogVisible = true;
          this.$nextTick(() => {
            this.$refs.ImportDialog.openDialog();
          });
          break

        case 'bulkedit':
          if (this.multipleSelection.length == 0) {
            this.$message({
              message: '请至少选择一条数据',
              type: 'error',
            })
            return
          }
          this.showBatchEditDialog()
          break
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error',
            })
            return
          }
          this.handleDelete(this.multipleSelection)
          break
        case 'btnExport':
          this.$refs.mainTable.exportExcel('资源文件', callback)
          break
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      // 构建传递给后端的参数
      const params = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
      }

      // 只添加有值的筛选条件
      if (this.listQuery.name) params.name = this.listQuery.name
      if (this.listQuery.code) params.code = this.listQuery.code
      if (this.listQuery.assetCode) params.assetCode = this.listQuery.assetCode
      if (this.listQuery.model) params.model = this.listQuery.model
      if (this.listQuery.status) params.status = this.listQuery.status

      // 打印传递给后端的参数
      console.log('传递给后端的参数:', JSON.stringify(params, null, 2))

      assetAccessorys.getList(params).then((response) => {
        this.list = response.data
        this.total = response.count
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleReset() {
      // 重置所有筛选条件
      this.listQuery = {
        page: 1,
        limit: 20,
        name: undefined,
        code: undefined,
        assetCode: undefined,
        model: undefined,
        status: undefined,
      }
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    handleModifyStatus(row, disable) {
      // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.disable = disable
    },
    resetTemp() {
      let obj = {};
      this.headerList.forEach((item) => {
        obj[item.columnName] = defaultVal(item.entityType)
      })
      this.temp = Object.assign({}, obj) // copy obj
    },
    handleCreate() {
      // 弹出添加框
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      // 保存提交
      this.$refs['dataForm'].validate(() => {
        assetAccessorys.add(this.temp).then(() => {
          this.list.unshift(this.temp)
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleUpdate(row) {
      // 弹出编辑框
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      // 更新提交
      this.$refs['dataForm'].validate(() => {
        const tempData = Object.assign({}, this.temp)
        assetAccessorys.update(tempData).then(() => {
          for (const v of this.list) {
            if (v.id === this.temp.id) {
              const index = this.list.indexOf(v)
              this.list.splice(index, 1, this.temp)
              break
            }
          }
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleDelete(rows) {
      // 多行删除
      this.delrows(assetAccessorys, rows)
    },
    // 显示批量修改对话框
    showBatchEditDialog() {
      this.dialogVisible = true;
      // 重置表单
      this.$nextTick(() => {
        this.$refs.batchForm.resetFields();
        this.inputType = 'text';
      });
    },

    // 关闭对话框前处理
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done();
        })
        .catch(() => { });
    },

    // 下拉选择变化时调整输入框类型
    handleFieldChange(value) {
      const selectedColumn = this.headerList.find(item => item.columnName === value);
      if (selectedColumn) {
        switch (selectedColumn.entityType) {
          case 'int':
          case 'decimal':
            this.inputType = 'number';
            break;
          case 'DateTime':
            this.inputType = 'date';
            break;
          default:
            this.inputType = 'text';
            break;
        }
      }
    },

    // 确认批量修改
    handleBatchUpdate() {
      if (!this.batchForm.field || !this.batchForm.value) {
        this.$message.warning('请选择字段并输入新值');
        return;
      }
      const updateData = {
        field: this.batchForm.field,
        value: this.batchForm.value,
        ids: this.multipleSelection.map(row => row.id)
      };
      console.log('提交给后端的数据:', JSON.stringify(updateData, null, 2));
      assetAccessorys.saveBatchUpdate(updateData).then(() => {
        this.$message.success('批量修改成功');
        this.dialogVisible = false;
        this.getList();
      }).catch(err => {
        this.$message.error('批量修改失败: ' + (err.message || '未知错误'));
      });
    },

    // 配件收回
    handleRecovery() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请至少选择一条配件',
          type: 'warning',
        })
        return
      }

      this.$confirm('确认收回选中的配件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const recoveryData = {
          ids: this.multipleSelection.map(row => row.id)
        }

        console.log('=== 配件收回 - 提交给后端的数据 ===')
        console.log(JSON.stringify(recoveryData, null, 2))
        console.log('说明：后端需要将这些配件的状态改为"收回"，更新登记日期和登记人，清空资产编号和资产名称')

        // 调用后端接口
        assetAccessorys.recovery(recoveryData).then(() => {
          this.$message.success('配件收回成功')
          this.getList()
        }).catch(err => {
          this.$message.error('配件收回失败: ' + (err.message || '未知错误'))
        })
      }).catch(() => {
        this.$message.info('已取消收回')
      })
    },

    // 配件使用 - 打开对话框
    handleAccessoryUsage() {
      if (this.multipleSelection.length !== 1) {
        this.$message({
          message: '请选择一条配件',
          type: 'warning',
        })
        return
      }

      this.currentAccessory = this.multipleSelection[0]

      // 检查数量
      if (this.currentAccessory.totalQty <= 0) {
        this.$message({
          message: '该配件数量为0，无法使用',
          type: 'warning',
        })
        return
      }

      // 重置表单
      this.useForm = {
        assetCode: '',
        assetName: '',
        updateTime: ''
      }
      this.useDialogVisible = true
    },

    // 配件使用 - 确认提交
    handleAccessoryUse() {
      if (!this.useForm.assetCode || !this.useForm.assetName || !this.useForm.updateTime) {
        this.$message.warning('请填写完整信息')
        return
      }

      const useData = {
        id: this.currentAccessory.id,
        assetCode: this.useForm.assetCode,
        assetName: this.useForm.assetName,
        updateTime: this.useForm.updateTime
      }

      console.log('=== 配件使用 - 提交给后端的数据 ===')
      console.log(JSON.stringify(useData, null, 2))
      console.log('说明：')
      console.log('1. 复制当前配件新增一条记录，数量为1，状态改为"在用"，更新登记日期和登记人')
      console.log('2. 原配件数量-1，如果数量为0则删除原配件')

      // 调用后端接口
      assetAccessorys.use(useData).then(() => {
        this.$message.success('配件使用成功')
        this.useDialogVisible = false
        this.getList()
      }).catch(err => {
        this.$message.error('配件使用失败: ' + (err.message || '未知错误'))
      })
    },

    // 打开资产选择器
    openAssetSelector() {
      this.assetSelectorVisible = true
      this.assetSearchKey = ''
      this.assetQuery = {
        page: 1,
        limit: 10,
        key: undefined
      }
      this.getAssetList()
    },

    // 获取资产列表
    getAssetList() {
      this.assetListLoading = true
      const params = {
        page: this.assetQuery.page,
        limit: this.assetQuery.limit
      }
      if (this.assetQuery.key) {
        params.key = this.assetQuery.key
      }

      assetInfos.getList(params).then((response) => {
        this.assetList = response.data
        this.assetTotal = response.count
        this.assetListLoading = false
      }).catch(() => {
        this.assetListLoading = false
      })
    },

    // 搜索资产
    searchAssets() {
      this.assetQuery.key = this.assetSearchKey
      this.assetQuery.page = 1
      this.getAssetList()
    },

    // 选择资产
    selectAsset(row) {
      this.useForm.assetCode = row.assetCode
      this.useForm.assetName = row.assetName
      this.assetSelectorVisible = false
      this.$message.success('已选择资产：' + row.assetCode)
    },

    // 资产列表分页
    handleAssetPageChange(val) {
      this.assetQuery.page = val.page
      this.assetQuery.limit = val.limit
      this.getAssetList()
    },
  },
}
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
